import { inject, Injectable, Type } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Injectable({ providedIn: 'root' })
export class DialogService {
  #dialog = inject(MatDialog);

  open<T, K>(component: Type<T>, data?: K, config: MatDialogConfig = {}) {
    return this.#dialog
      .open(component, {
        ...config,
        maxWidth: '90vw',
        // width: '30rem',
        data,
      })
      .afterClosed();
  }
}
